import React, { createContext, useContext, ReactNode } from 'react';
import { useOrgSync } from '../hooks/useOrgSync';
import { Organization } from '@osnova/org-sync';

interface OrgSyncContextType {
  currentOrg: Organization | null;
  setOrganization: (org: Organization | null) => void;
  clearOrganization: () => void;
  isLoaded: boolean;
  error: any;
  isInitializing: boolean;
}

const OrgSyncContext = createContext<OrgSyncContextType | undefined>(undefined);

interface OrgSyncProviderProps {
  children: ReactNode;
}

/**
 * Провайдер для синхронизации организации
 * ВАЖНО: Должен быть один на всё приложение
 */
export const OrgSyncProvider: React.FC<OrgSyncProviderProps> = ({ children }) => {
  // ОДИН экземпляр org-sync на всё приложение
  const orgSyncData = useOrgSync();

  return (
    <OrgSyncContext.Provider value={orgSyncData}>
      {children}
    </OrgSyncContext.Provider>
  );
};

/**
 * Хук для доступа к контексту синхронизации организации
 */
export const useOrgSyncContext = (): OrgSyncContextType => {
  const context = useContext(OrgSyncContext);
  if (context === undefined) {
    throw new Error('useOrgSyncContext must be used within an OrgSyncProvider');
  }
  return context;
};
